<app-modal-container [title]="title" (action)="findAndReplace()">
  <form [formGroup]="findReplaceFormGroup">
    <app-md-input [label]="'Search for:'" formControlName="find"></app-md-input>
    <app-md-input [label]="'Replace with:'" formControlName="replace"></app-md-input>
  </form>
</app-modal-container>
